import { environment } from '../environments/environment';
import {
  API_HOST_BY_FE_HOST,
  FALLBACK_API_HOST,
} from '../constants/domains';

type FEHost = keyof typeof API_HOST_BY_FE_HOST;

export function getAPIURLByDomain(): string {
  const hostname = window.location.hostname;
  const apiHost = API_HOST_BY_FE_HOST[hostname as FEHost];

  if (!apiHost) {
    // localhost and preview builds land here by design and talk to alpha. A
    // production build landing here means the deployment is missing from
    // API_HOST_BY_FE_HOST, so say so instead of failing silently.
    if (environment.production) {
      // eslint-disable-next-line no-console
      console.warn(
        `[customer] no backend mapped for host "${hostname}" — falling back to ${FALLBACK_API_HOST}`
      );
    }
    return `https://${FALLBACK_API_HOST}`;
  }

  return `https://${apiHost}`;
}
